import React from 'react';
// import TitleText from './TitleText';
// import BodyText from './BodyText';
import { Box, Grid, makeStyles } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import BodyText from '../../components/reusableComponents/BodyText';
// import Background from '../../../assets/images/textBackground.svg';

const useStyles = makeStyles((theme) => ({
	loginButton: {
		backgroundColor: 'white',
		color: '#E61855',
		borderColor: '#E61855',
		borderRadius: 15,
		width: '100%',
		paddingLeft: 30,
		paddingTop: 14,
		paddingBottom: 14,
		paddingRight: 30,
		// marginBottom: 20,
		'&:hover': {
			backgroundColor: 'white',
		},
	},
	registerButton: {
		backgroundColor: '#E61855',
		color: 'white',
		marginLeft: 15,
		borderColor: '#E61855',
		borderRadius: 15,
		width: '100%',
		paddingLeft: 30,
		paddingTop: 14,
		paddingBottom: 14,
		paddingRight: 30,
		// padding: 12,
		// marginBottom: 20,
		'&:hover': {
			backgroundColor: '#E61855',
		},
	},
	earlyExcess: {
		backgroundColor: '#E61855',
		color: 'white',
		marginLeft: 15,
		borderColor: '#E61855',
		borderRadius: 15,
		// width: '20%',
		paddingLeft: 50,
		paddingTop: 14,
		paddingBottom: 14,
		paddingRight: 50,
		// padding: 12,
		// marginBottom: 20,
		'&:hover': {
			backgroundColor: '#E61855',
		},
	},
	lpImgOne: {
		zIndex: 2,
		width: '100%',
		position: 'relative',
	},
	lpImgTwo: {
		width: '100%',
		position: 'absolute',
		left: '0',
		top: '0%',
	},
	sectionThreecardImg: {
		width: '100%',
	},
	sectionThreecard: {
		backgroundColor: '#fff',
		width: '100%',
		padding: '8%',
		borderRadius: '20px',
		boxShadow: '0px 5px 40px rgba(3, 98, 175, 0.1)',
		marginBottom: '5vh',
	},
	LPCon: {
		width: '100%',
	},
	paper: {
		width: '100%',
		height: '100px',
		backgroundColor: '#E6F0F7',
		opacity: ' 0.87',
		borderRadius: '10px',
		boxShadow: 'none',
		margin: '3vh 0',
	},
	LPSectionSix: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		backgroundColor: '#E6F0F7',
		overflow: 'hidden',
		color: '#00325B',
		paddingBottom: '6vh',
	},

	dataSec6ConTop: {
		marginTop: '1vh',
		display: 'flex',
		width: '300%',
	},
	dataSec6ConTopBtn: {
		outline: 'none',
		border: 'none',
		background: '#E6F0F7',
		padding: '1vh 1vw',
		opacity: ' 0.3',
		margin: '0 20px',
	},
	dataSec6ConBottom: {
		position: 'relative',
		transition: 'all 0.5s ease',
		display: 'flex',
		width: '400vw',
	},
	dataSec6ConBottomLB: {
		position: 'fixed',
		left: 0,
		top: 0,
		width: '70px',
		height: '50px',
		backgroundColor: '#000',
	},
	dataSec6bCard: {
		display: 'flex',
		flexDirection: 'column',
		width: '100vw',
		marginTop: '1.5vh',
		padding: '0 10vw',
		position: 'relative',
	},

	accordionSummary: {
		flexDirection: 'row-reverse',
		width: '100%',
		padding: 0,
	},
}));
const FAQ = ({ itinerary }) => {
	const classes = useStyles();
	const [expanded, setExpanded] = React.useState(false);
	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};
	console.log('first', itinerary);
	return (
		<>
			<Grid container style={{ marginBottom: 40 }}>
				<Grid item xs={12}>
					<Box className={classes.LPSectionEight + ' LPSectionEight'}>
						<Box className={classes.LPCon}>
							<Box className='accordianDiv' style={{ marginTop: 60 }}>
								{itinerary.map((i, index) => {
									return (
										<Accordion
											expanded={expanded === `panel${index + 1}`}
											onChange={handleChange(`panel${index + 1}`)}>
											<AccordionSummary
												className={classes.accordionSummary}
												expandIcon={<ArrowRightIcon />}
												aria-controls='panel1a-content'
												id='panel1a-header'>
												<p className='accordionHead'>{i.title}</p>
											</AccordionSummary>
											<AccordionDetails>
												<BodyText
													one
													textStyle={{
														textAlign: 'justify',
														fontSize: '14px',
														fontWeight: 500,
													}}>
													{i.desc}
												</BodyText>
											</AccordionDetails>
										</Accordion>
									);
								})}

								{/* <Accordion
									expanded={expanded === 'panel2'}
									onChange={handleChange('panel2')}>
									<AccordionSummary
										className={classes.accordionSummary}
										expandIcon={<ArrowRightIcon />}
										aria-controls='panel1a-content'
										id='panel1a-header'>
										<p className='accordionHead'>Day 2 Leh</p>
									</AccordionSummary>
									<AccordionDetails>
										<BodyText
											one
											textStyle={{
												textAlign: 'justify',
												fontSize: '14px',
												fontWeight: 500,
											}}>
											Today we visit Shey Palace – used to be the summer retreat
											of the royal family of Ladakh, Rancho School - also known
											as Druk White Lotus school, Hemis Gompa – a Himalayan
											Buddhist monastery which is believed to be the wealthiest
											and the biggest monastery in Leh followed by a Photo stop
											at Thiksey monastery. Further we witness a Sindhu Darshan
											- one of the longest rivers in Asia, Hall of Fame War
											Museum – a museum constructed by the Indian Army in memory
											of the brave Indian soldiers who laid down their lives
											defending the motherland in the Indo-Pak wars. Later we
											have free time for shopping.
										</BodyText>
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={expanded === 'panel3'}
									onChange={handleChange('panel3')}>
									<AccordionSummary
										className={classes.accordionSummary}
										expandIcon={<ArrowRightIcon />}
										aria-controls='panel1a-content'
										id='panel1a-header'>
										<p className='accordionHead'>
											Day 3 Leh – Khardung La Pass – Nubra Valley (2N)
										</p>
									</AccordionSummary>
									<AccordionDetails>
										<BodyText
											one
											textStyle={{
												textAlign: 'justify',
												fontSize: '14px',
												fontWeight: 500,
											}}>
											Today we proceed to Nubra Valley via Khardung La - the
											world’s highest motorable pass. Nubra valley - the Shyok
											River meets the Siachen River to form this large valley
											separating the Ladakh and Karakoram ranges. Upon arrival
											we visit Maitreya Buddha – Perched on top of a monastery,
											it is the statue of Jampa Buddha, noted for its intricate
											carvings, brilliant craftsmanship and vivid colours. Later
											we visit Hunder Village and Cold desert - the only place
											in India where twin humped camels are found
										</BodyText>
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={expanded === 'panel4'}
									onChange={handleChange('panel4')}>
									<AccordionSummary
										className={classes.accordionSummary}
										expandIcon={<ArrowRightIcon />}
										aria-controls='panel1a-content'
										id='panel1a-header'>
										<p className='accordionHead'>
											Day 4 Nubra Valley – Turtuk – Thang – Nubra Valley
										</p>
									</AccordionSummary>
									<AccordionDetails>
										<BodyText
											one
											textStyle={{
												textAlign: 'justify',
												fontSize: '14px',
												fontWeight: 500,
											}}>
											Today we proceed to Turtuk village which was first opened
											for the tourists in the year 2010, while visiting Turtuk
											we pass by Thoise Airport (Military Airfield), then we
											visit Turtuk wooden bridge and Shyok war memorial. Later
											we walk through Baltic village. Further we visit Thang
											village (Subject to operation)- Northern most last village
											at LOC. Here we take a photo stop at LOC point
										</BodyText>
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={expanded === 'panel5'}
									onChange={handleChange('panel5')}>
									<AccordionSummary
										className={classes.accordionSummary}
										expandIcon={<ArrowRightIcon />}
										aria-controls='panel1a-content'
										id='panel1a-header'>
										<p className='accordionHead'>
											Day 5 Nubra Valley – Pangong Tso (1N)
										</p>
									</AccordionSummary>
									<AccordionDetails>
										<BodyText
											one
											textStyle={{
												textAlign: 'justify',
												fontSize: '14px',
												fontWeight: 500,
											}}>
											Today we proceed to Pangong Tso, also known as Pangong
											Lake - one of the world's highest saltwater lakes. The
											most notable feature of this lake are its ever-changing
											hues. The lake acts as an important breeding ground for a
											large variety of migratory birds like Brahmani Ducks, Rare
											black necked cranes and Seagulls.
										</BodyText>
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={expanded === 'panel6'}
									onChange={handleChange('panel6')}>
									<AccordionSummary
										className={classes.accordionSummary}
										expandIcon={<ArrowRightIcon />}
										aria-controls='panel1a-content'
										id='panel1a-header'>
										<p className='accordionHead'>
											Day 6 Pangong Tso – Leh (1N)
										</p>
									</AccordionSummary>
									<AccordionDetails>
										<BodyText
											one
											textStyle={{
												textAlign: 'justify',
												fontSize: '14px',
												fontWeight: 500,
											}}>
											Today we Proceed to Leh via Changla pass, one of the
											highest motor-able road in the world. The name Changla
											pass literally means "Northern Pass" (Chang means north
											and La means Pass). In the evening, we enjoy the Folk
											dance show
										</BodyText>
									</AccordionDetails>
								</Accordion> */}
							</Box>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</>
	);
};

export default FAQ;
